import React from 'react';
import PropTypes from 'prop-types';

import {planPropTypes} from '../../../utils/propTypes';

import DetailsFeatures from './DetailsFeatures';
import DetailsOptions from './DetailsOptions';
import DetailsSubscribe from './DetailsSubscribe';
import ShowMore from './ShowMore';

const isShowMoreNeeded = (maxDefaultFeatures, plan) => plan?.features?.length > maxDefaultFeatures;

function Details(props) {
  const [showMoreNeeded] = React.useState(isShowMoreNeeded(props.maxDefaultFeatures, props.plan));
  const [isOpen, setIsOpen] = React.useState(!showMoreNeeded);

  function toggleIsOpen() {
    setIsOpen(current => !current);
  }

  return (
    <>
      <DetailsFeatures
        {...props}
        isOpen={isOpen}
      />
      <DetailsOptions
        {...props}
        isOpen={isOpen}
      />
      <DetailsSubscribe
        {...props}
        showSubscribeButton={showMoreNeeded}
        isOpen={isOpen}
      />
      {showMoreNeeded &&
        <ShowMore
          {...props}
          isOpen={isOpen}
          toggleIsOpen={toggleIsOpen}
        />
      }
    </>
  );
}

Details.propTypes = {
  plan: planPropTypes().isRequired,
  maxDefaultFeatures: PropTypes.number.isRequired,
  onPlanSelection: PropTypes.func.isRequired
};

export default Details;
